// export const API_BASE_URL = "https://arbitrage-services-graphs-v2.org/api"
// export const OUTER_API_BASE_URL = "https://arbitrage-services-graphs-v2.org/api"
// export const SOCKET_URL = "wss://arbitrage-services-graphs-v2.org"
export const API_BASE_URL = "https://arbitrage-services.ru/api"
export const OUTER_API_BASE_URL = "https://arbitrage-services.ru/api"
export const SOCKET_URL = "wss://arbitrage-services.ru"
